export enum OverlayColor {
  WHITE = 'overlay-white',
  BLACK = 'overlay-black'
}
